import { render, staticRenderFns } from "./compRegPC.vue?vue&type=template&id=9d1854aa&scoped=true"
import script from "./compRegPC.vue?vue&type=script&lang=js"
export * from "./compRegPC.vue?vue&type=script&lang=js"
import style0 from "./compRegPC.vue?vue&type=style&index=0&id=9d1854aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1854aa",
  null
  
)

export default component.exports